/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NotificationPreferenceDeliveryScopeType = {
    Facility: 'FACILITY',
    Source: 'SOURCE'
} as const;
export type NotificationPreferenceDeliveryScopeType = typeof NotificationPreferenceDeliveryScopeType[keyof typeof NotificationPreferenceDeliveryScopeType];


export function NotificationPreferenceDeliveryScopeTypeFromJSON(json: any): NotificationPreferenceDeliveryScopeType {
    return NotificationPreferenceDeliveryScopeTypeFromJSONTyped(json, false);
}

export function NotificationPreferenceDeliveryScopeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceDeliveryScopeType {
    return json as NotificationPreferenceDeliveryScopeType;
}

export function NotificationPreferenceDeliveryScopeTypeToJSON(value?: NotificationPreferenceDeliveryScopeType | null): any {
    return value as any;
}

